import React from "react";
export function getCard(card, cardKey) {
  if (card && typeof card !== "object") {
    return card;
  } else if (card && cardKey) {
    return card[cardKey];
  }
  return null;
}
export function getWidthOfColumn(length, header) {
  let percentage = Number(header.basis?.replace("%", "") || NaN);
  return !Number.isNaN(percentage) ? percentage * length / 100 : 1;
}
export function buildColumns(header, Card, i18n) {
  return header?.reduce((acc, h) => {
    acc[h.label[0]] = {
      disableColumnMenu: false,
      filterable: false,
      field: h.label[0],
      flex: getWidthOfColumn(header?.length, h),
      renderCell: params => {
        const {
          value
        } = params;
        return /*#__PURE__*/React.createElement(Card, {
          type: h.type || "",
          value: value
        });
      },
      headerName: i18n`${h.label[0]}`,
      align: h?.align || "left",
      headerAlign: h?.align || "left"
    };
    return acc;
  }, {});
}
export function buildRows(listItems, header) {
  return listItems?.map((row, index) => {
    const dataGridRow = {};
    row.card.forEach((card, i) => {
      if (!card?.length) {
        return;
      }
      const headerName = header?.[i]?.label?.[0];
      dataGridRow[headerName] = card[0].value;
      dataGridRow["link"] = {
        to: row.link?.to
      };
      dataGridRow["id"] = row.id || index;
      row.detailPanel && (dataGridRow["detailPanel"] = row.detailPanel);
    });
    return dataGridRow;
  });
}